import React from "react";
import PropTypes from "prop-types";
import { StyledHeading, StyledWrapper, StyledWrapperFullWidth } from "./styles";

const SectionTitle = ({
  children,
  context,
  clientContext,
  fullWidth = false,
  style,
  size = "large",
}) => {
  if (fullWidth) {
    return (
      <StyledWrapperFullWidth
        clientContext={clientContext}
        style={{ ...style }}
        size={size}
      >
        <span>{children}</span>
      </StyledWrapperFullWidth>
    );
  } else {
    return (
      <StyledHeading clientContext={clientContext} style={{ ...style }}>
        <StyledWrapper clientContext={clientContext} size={size}>
          <span>{children}</span>
        </StyledWrapper>
      </StyledHeading>
    );
  }
};

export default SectionTitle;

SectionTitle.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object,
  /**
   Server side variables
  */
  context: PropTypes.object,
  /**
   Child objects
  */
  children: PropTypes.string,
  /**
   is Full Width
  */
  fullWidth: PropTypes.bool,
};
